import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Translation } from 'react-i18next';
import PropTypes from 'prop-types';
import { loginCopy } from '../copy/loginCopy.json';
import PlayButton from './utility/PlayButton';
import IntroductionButton from './utility/IntroductionButton';
import { fireGTM } from '../gtm/gtmUtil';
import { introCTAButtons_GTM } from '../gtm/datalayers/introDataLayers.json';

class IntroImage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      playButtonColor: 'white',
      introductionButtonColor: 'white',
    };
  }

  hidden = {
    visibility: 'hidden',
  };

  notHidden = {
    display: 'flex',
    alignItems: 'center',
  };

  heroImageBackground = () => {
    const heroRight =
      this.props.tenant.heroImgPortrait || this.props.tenant.hero;
    return {
      background: `no-repeat center url(${heroRight})`,
      backgroundSize: 'cover',
    };
  };

  handleIntroCTAClick = (dataLayer) => {
    fireGTM(dataLayer);
  };

  render() {
    return (
      <Translation>
        {(t) => (
          <div className="main-right" style={this.heroImageBackground()}>
            <div className="campus-img" alt="campus" />
            <div className="intro-container">
              <div
                className="intro-icon-container intro-icon-left"
                style={this.props.showTutorial ? this.notHidden : this.hidden}
              >
                <Link
                  role="button"
                  className="label-text intro-text white-text"
                  to="introduction?video=true"
                  onClick={() =>
                    this.handleIntroCTAClick(introCTAButtons_GTM.watchVideo)
                  }
                  onMouseOver={() => {
                    this.setState({ playButtonColor: '#4a4a4a' });
                  }}
                  onFocus={() => {
                    this.setState({ playButtonColor: '#4a4a4a' });
                  }}
                  onMouseLeave={() => {
                    this.setState({ playButtonColor: 'white' });
                  }}
                  onBlur={() => {
                    this.setState({ playButtonColor: 'white' });
                  }}
                  style={this.props.showTutorial ? this.notHidden : this.hidden}
                >
                  <div
                    className="intro-icon"
                    alt="play"
                    style={
                      this.props.showTutorial ? this.notHidden : this.hidden
                    }
                  >
                    <PlayButton color={this.state.playButtonColor} />
                  </div>
                  {t('Watch: What is {{appName}}?', { appName: 'me3' })}
                </Link>
              </div>
              <div
                className="intro-icon-container intro-icon-right"
                style={this.props.showTutorial ? this.notHidden : this.hidden}
              >
                <Link
                  role="button"
                  className="label-text intro-text white-text"
                  to="introduction"
                  onClick={() =>
                    this.handleIntroCTAClick(introCTAButtons_GTM.readIntro)
                  }
                  style={this.props.showTutorial ? this.notHidden : this.hidden}
                  onMouseOver={() => {
                    this.setState({ introductionButtonColor: '#4a4a4a' });
                  }}
                  onFocus={() => {
                    this.setState({ introductionButtonColor: '#4a4a4a' });
                  }}
                  onMouseLeave={() => {
                    this.setState({ introductionButtonColor: 'white' });
                  }}
                  onBlur={() => {
                    this.setState({ introductionButtonColor: 'white' });
                  }}
                >
                  <div
                    className="intro-icon"
                    alt="read"
                    style={
                      this.props.showTutorial ? this.notHidden : this.hidden
                    }
                  >
                    <IntroductionButton
                      color={this.state.introductionButtonColor}
                    />
                  </div>
                  {t('Read {{appName}} introduction', { appName: 'me3' })}
                </Link>
              </div>
            </div>
          </div>
        )}
      </Translation>
    );
  }
}

IntroImage.propTypes = {
  showTutorial: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
  const tenant = state.tenant;

  return { tenant };
};

export default connect(mapStateToProps, {})(IntroImage);
